import { useCallback, useEffect, useState } from 'react';
import { CashoutOffer, getCashoutOffers } from 'services/api/slipService';

const REFRESH_MS = 5000;

/** Cash out offers for the player's open tickets, asked again every few
 * seconds while `active` (My Bets showing open tickets). */
export const useCashoutOffers = (active: boolean) => {
  const [offers, setOffers] = useState<Map<number, CashoutOffer>>(new Map());
  // Offers cover every open ticket while cash out is on; off, none come.
  const [enabled, setEnabled] = useState(false);

  const refresh = useCallback(async () => {
    const res = await getCashoutOffers();
    if (!res) return;
    setEnabled(res.enabled);
    setOffers(
      res.enabled
        ? new Map(res.offers.map((o) => [Number(o.ticket_id), o]))
        : new Map()
    );
  }, []);

  useEffect(() => {
    if (!active) {
      setOffers(new Map());
      return;
    }
    refresh();
    const id = window.setInterval(refresh, REFRESH_MS);
    return () => window.clearInterval(id);
  }, [active, refresh]);

  return { offers, enabled, refresh };
};
